import { useSites } from '../../../context/SiteContext';
import { useReportVisits } from '../../../hooks/useReportVisits';
import { buildPages } from '../../../lib/analytics';
import { formatNumber } from '../../../lib/format';
import EmptyState from '../../../components/dashboard/EmptyState';
import PageHeader from '../../../components/dashboard/PageHeader';
import StatTable from '../../../components/dashboard/StatTable';
import ExportButton from '../../../components/dashboard/ExportButton';

export default function EntryPage() {
  const { currentSite } = useSites();
  const { ranged, range } = useReportVisits(currentSite);
  const pages = buildPages(ranged).filter((p) => p.entry > 0).sort((a, b) => b.entry - a.entry);
  const columns = ['入口页面', '进入次数', '浏览量', '访客'];
  const rows = pages.map((p) => [p.path, formatNumber(p.entry), formatNumber(p.pv), formatNumber(p.uv)]);

  if (!currentSite) return <EmptyState title="先添加一个站点" desc="添加站点后可查看入口页。" />;

  return (
    <div>
      <PageHeader
        title="入口页面"
        desc="访客第一次打开的页面，反映推广落地是否准确。"
        range={range}
        extra={<ExportButton filename={`${currentSite.domain}-entry.csv`} columns={columns} rows={rows} />}
      />
      <div className="mt-6 rounded-lg border border-background-200 bg-background-50 overflow-hidden">
        <StatTable columns={columns} rows={rows} empty="当前时段暂无入口页数据" />
      </div>
    </div>
  );
}
